import Logo from "../../triquetra-full-logo.svg";
import axios from "axios";

const host = process.env.REACT_APP_HOST;
const Navbar = ({ toggleModal }) => {
  async function loadManual() {
    try {
      const response = await axios.post(
        `${host}/getManual`,
        {},
        { responseType: "blob" }
      );

      // Check if the response contains data
      if (!response.data) {
        console.error("Empty response");
      }

      // Create a blob object from the response data
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      if (response.headers["content-type"] === "application/pdf") {
        // If it's a PDF, open it in a new tab
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        window.URL.revokeObjectURL(url);
        return true;
      } else {
        console.error("Not a PDF file");
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  return (
    <div className="dss-navbar">
      <a href="./">
        <img src={Logo} alt="Company Logo" className="logo" id="logoImage" />
      </a>
      <div className="nav-buttons">
        <button className="about-button" onClick={loadManual}>
          {" "}
          Manual
        </button>
        <button className="about-button" onClick={toggleModal}>
          {" "}
          About
        </button>
      </div>
    </div>
  );
};

export default Navbar;
